import { render, staticRenderFns } from "./VerifyDoubleAuthentificationCode.vue?vue&type=template&id=18d82ce9&scoped=true"
import script from "./VerifyDoubleAuthentificationCode.vue?vue&type=script&lang=js"
export * from "./VerifyDoubleAuthentificationCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyDoubleAuthentificationCode.vue?vue&type=style&index=0&id=18d82ce9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d82ce9",
  null
  
)

export default component.exports